import { createContext } from "react";

export const UserContext = createContext({
    auth : false,
    userId : null,
    username : null,
    image : null,
});